export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
        if (process.env.NODE_ENV !== 'production') console.log('SW registered:', registration.scope);
        })
        .catch((error) => {
        if (process.env.NODE_ENV !== 'production') console.log('SW registration failed:', error);
        });
    });
  }
}
